import { Td, Text, Tr } from "@chakra-ui/react";
import { useState } from "react";
import { Product, ProductField } from "../../../../../common/types";
import { ProductFieldCell } from "../../../../../common/products/ProductFieldCell";

interface ProductRowProps {
  product: Product;
  productForComparison?: Product;
  showComparison: boolean;
}

export const ProductRow = ({ product, productForComparison, showComparison }: ProductRowProps) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const toggle = () => setIsExpanded((expanded) => !expanded);

  const unitPrice = product.unitPrice?.value ?? undefined;
  const compareUnitPrice = productForComparison?.unitPrice?.value ?? undefined;
  const delta = unitPrice != null && compareUnitPrice != null ? unitPrice - compareUnitPrice : undefined;
  const deltaColor = delta == null ? "smMuted" : delta < 0 ? "green.500" : delta > 0 ? "red.500" : "smMuted";

  return (
    <Tr>
      {product.productFields
        .filter((field: ProductField) => field.populatedBy === "Buyer")
        .map((field: ProductField) => (
          <ProductFieldCell
            key={field.id}
            value={field.value}
            isBoolean={field.type === "Boolean"}
            isExpanded={isExpanded}
            onToggle={toggle}
            pb={isExpanded ? "2" : "0"}
          />
        ))}
      <Td verticalAlign="top">{product.quantity?.value ?? "—"}</Td>
      <Td verticalAlign="top">
        <Text fontWeight="semibold" color="smPrimary">
          {unitPrice != null ? unitPrice.toLocaleString() : "—"}
        </Text>
      </Td>
      {showComparison && (
        <>
          <Td verticalAlign="top">
            <Text fontWeight="semibold" color="smSecondary">
              {compareUnitPrice != null ? compareUnitPrice.toLocaleString() : "—"}
            </Text>
          </Td>
          <Td color={deltaColor} verticalAlign="top">
            <Text fontWeight="semibold">{delta != null ? (delta === 0 ? "0" : delta.toLocaleString()) : "—"}</Text>
          </Td>
          <Td color={deltaColor} verticalAlign="top">
            <Text fontWeight="semibold">
              {unitPrice != null && compareUnitPrice != null && compareUnitPrice !== 0
                ? `${(Math.round(((unitPrice - compareUnitPrice) / compareUnitPrice) * 100 * 10) / 10).toLocaleString()}%`
                : "—"}
            </Text>
          </Td>
        </>
      )}
      {product.productFields
        .filter((field: ProductField) => field.populatedBy === "Supplier")
        .map((field: ProductField) => (
          <ProductFieldCell
            key={field.id}
            value={field.value}
            isBoolean={field.type === "Boolean"}
            isExpanded={isExpanded}
            onToggle={toggle}
          />
        ))}
    </Tr>
  );
};
